import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import LeftContentQuickOrder from "components/QuickOrder/LeftContentQuickOrder"
import RightContentQuickOrder from "components/QuickOrder/RightContentQuickOrder"

export default function QuickOrder() {
    useEffect(() => {
        document.body.classList.add("NoneHeaderFooter");

        return () => {
            document.body.classList.remove("NoneHeaderFooter");
        };
    }, []);

    return (
        <Layout>
            <div className="MuiContainer-root styles_container__eEOzu MuiContainer-disableGutters MuiContainer-maxWidthLg">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-9 w-full-1199 px-1199-100-140">
                        <div className="styles_containerBreadcrumbs__K4TEO hidden-1199">
                            <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                                <ol className="MuiBreadcrumbs-ol">
                                    <li className="MuiBreadcrumbs-li">
                                        <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                        </svg>
                                    </li>
                                    <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Đặt hàng nhanh</span>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <LeftContentQuickOrder />
                    </div>
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 total-quick-order-sidebar">
                        <RightContentQuickOrder />
                    </div>
                </div>
            </div>
        </Layout>
    )
}
